// extracted by mini-css-extract-plugin
export default {"container":"BreadCrumbs_container__gQqq8","item":"BreadCrumbs_item__jw8b3","dot":"BreadCrumbs_dot__swdX6","last":"BreadCrumbs_last__46W2Q"};